<div class="side-menu-button cursor-pointer" (click)="toggleSideMenu()" [ngClass]="{ isSideMenuOpened: isOpen }">
    <fa-icon [icon]="faBars" size="lg"></fa-icon>
</div>
<div
    class="side-menu-container container-fluid"
    [ngClass]="{
        isOpening: isOpen,
        isClosing: !isOpen && hasBeenOpened,
    }"
    tabindex="0"
>
    <div class="sticky-menu position-sticky top-0 start-0"></div>

    @if (model.sections.length > 1) {
        @for (section of model.sections; track section; let isFirst = $first; let isLast = $last) {
            <!-- Section Header -->
            <div class="menu-section my-3 mx-0">
                <span>{{ section.title }}</span>
            </div>
            <!-- Menu Entries for Section -->
            @for (entry of section.entries; track entry) {
                @if (entry.visible) {
                    <pace-core-menu-entry [model]="entry" (click)="toggleSideMenu()"></pace-core-menu-entry>
                }
            }
            @if (isFirst) {
                <ng-content select="[paceWeeklyWorkTime]"></ng-content>
            }
            @if (isLast) {
                <pace-core-menu-entry [model]="barcodeClipboardEntry"></pace-core-menu-entry>
                @if (furtherLinks.length > 0) {
                    <div>
                        <div class="further-links-menu d-flex align-items-center">
                            <pace-core-menu-entry [model]="furtherLinksEntry"></pace-core-menu-entry>
                            <span class="chevron-icon-container cursor-pointer" (click)="toggleFurtherLinks()">
                                <fa-icon
                                    [icon]="isCollapsed ? faChevronDown : faChevronUp"
                                    aria-hidden="true"
                                ></fa-icon>
                            </span>
                        </div>
                        @if (showFurtherLinks) {
                            <ul class="further-links ps-5">
                                @for (link of furtherLinks; track link) {
                                    <li>
                                        <div paceCoreLink (click)="toggleSideMenu()">
                                            <a class="pace-link" href="{{ link.descText }}" target="_blank">{{
                                                link.code
                                            }}</a>
                                        </div>
                                    </li>
                                }
                            </ul>
                        }
                    </div>
                }
                <ng-content select="[paceInformation]"></ng-content>
                <pace-core-menu-entry [model]="reportIssueEntry"></pace-core-menu-entry>
                <ng-content select="[corporateInformationMenuEntry]"></ng-content>
                @if (isPWADisplayMode) {
                    @if (pushNotificationEntry$ | async; as pushNotificationEntry) {
                        <pace-core-menu-entry [model]="pushNotificationEntry"></pace-core-menu-entry>
                    }
                    <pace-core-menu-entry [model]="restartAppEntry"></pace-core-menu-entry>
                }
            }
        }
    } @else {
        @for (section of model.sections; track section) {
            @for (entry of section.entries; track entry) {
                @if (entry.visible) {
                    <pace-core-menu-entry [model]="entry" (click)="toggleSideMenu()"></pace-core-menu-entry>
                }
            }
        }
    }

    <!-- Looping over Empty Section -->
</div>
@if (isOpen) {
    <div
        class="side-menu-backdrop"
        (click)="toggleSideMenu()"
        [ngClass]="{
            isOpening: isOpen,
            isClosing: !isOpen && hasBeenOpened,
        }"
    ></div>
}
